import "./src/styles/global.css";
import {
	initAnalyticsIfConsented,
	trackPageView,
} from "./src/utils/analytics";

const runWhenIdle = callback => {
	if (typeof window !== "undefined" && "requestIdleCallback" in window) {
		window.requestIdleCallback(callback, { timeout: 1500 });
		return;
	}

	setTimeout(callback, 0);
};

export const onClientEntry = () => {
	// Fonts are now loaded via gatsby-ssr.js head injection (display=optional)
	runWhenIdle(() => {
		initAnalyticsIfConsented();
	});
};

export const onRouteUpdate = ({ location }) => {
	const pagePath = location ? `${location.pathname}${location.search || ""}` : undefined;
	trackPageView(pagePath);
};
